module.exports = __webpack_public_path__ + "static/media/ic_edit.afe87f19.webp";